import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LenderService } from '@shared/service/lender/lender.service';
import { CustomModal } from '@workflow/dynamic-render/page/shared/core-custom-page.decorator';
import { OnChangeFunctionsService } from '@workflow/ecp-workflow/dynamic-app/service/logic-functions/on-change-functions.service';
import { WorkflowPageNavigationService } from '@workflow/service/workflow-page-navigation/workflow-page-navigation.service';
import { WorkflowService } from '@workflow/service/workflow/workflow.service';
import { OaoOnClickFunctionsService } from '../../services/logic-functions/oao-on-click-functions.service';
import { StatefulService } from '@app/service/stateful.service';
import { FieldService, FieldInstance } from '@workflow/class/field.service';

@CustomModal('oao-confirm-membership')
@Component({
  selector: 'ecp-oao-confirm-membership',
  templateUrl: './confirm-membership.component.html'
})
export class ConfirmMembershipComponent implements OnInit {
  public membershipField: FieldInstance;
  private readonly statefulService = inject(StatefulService);
  // private readonly fieldService = inject(FieldService);
  constructor(
    public workflowPageNavigationService: WorkflowPageNavigationService,
    private readonly onChangeFn: OnChangeFunctionsService,
    private readonly oaoOnClick: OaoOnClickFunctionsService,
    private readonly workflowService: WorkflowService,
    private readonly router: Router,
    private readonly lenderService: LenderService,
    private readonly fieldService: FieldService
  ) {}

  ngOnInit(): void {
    const enhancedProductSelectionEnabled = this.lenderService?.lenderData?.enableEnhancedProductSelection;
    this.membershipField = enhancedProductSelectionEnabled
      ? this.fieldService.createField('oao-membership-list', this.workflowService.currentFlow.id)
      : this.fieldService.createField('oao-membership-list-dropdown', this.workflowService.currentFlow.id);
  }

  public confirmMembershipChange = (): void => {
    /** If yes, Clearing All fields */
    this.onChangeFn.clearOAOApplicationFields();
    this.onChangeFn.patchMembership({ field: this.membershipField });
    this.statefulService.wrap('mem:membershipChanged').value = true;
    this.statefulService.wrap('ss:showMembershipChangeModal').value = false;

    this.oaoOnClick.setOAOMembership({
      field: this.membershipField
    });

    this.workflowService.currentFlow.pages.forEach((p) => {
      this.workflowPageNavigationService.updateNavState(p);
    });

    this.router.navigate([`app/oao/${this.getOAOFlowType()}/eligibility`]);
  };

  public getOAOFlowType(): string {
    const membershipTypeName = this.statefulService.wrap('api:oaoMemberInformation/membership/membershipTypeName').valueString;
    const value = this.statefulService.wrap('api:oaoMemberInformation/membership/isYouth').valueString;
    const isYouth = value ? JSON.parse(value) : false;
    const flowType = isYouth ? 'youth' : membershipTypeName.toLowerCase();
    return flowType;
  }

  public cancelMembershipChangeModal = (): void => {
    this.membershipField.data.value = this.statefulService.wrap('api:oaoMemberInformation/membership/membershipID').value;
    this.onChangeFn.setMembershipTypeToMemStorage({ field: this.membershipField });
    this.statefulService.wrap('mem:membershipChanged').value = false;
    this.statefulService.wrap('ss:showMembershipChangeModal').value = false;
    return;
  };
}
